import { useId } from 'react';

/** Generates a stable id for label/control association. */
export function useFieldId(prefix: string): string {
  const id = useId();
  return `${prefix}-${id}`;
}
